<template>
  <!-- <label class="ux-field-title" v-if="showLabel">{{label}} <span class="ux-required-marker" v-if="required">*</span></label> -->
  <!-- <div class="ux-field-description" v-if="showDescription">{{description}}</div> -->
  <div v-if="multiValue">
    <flex-row class="ux-text-row">
      <flex-cell>
        <compile v-if="field.compile" :template="field.template" />

        <div v-else v-html="field.template" />
        <!-- <div
          v-html="field.template"
          :key="index"
          v-for="(entry, index) in model"
        ></div> -->
      </flex-cell>
      <flex-cell shrink vcenter>
        <ux-button tag="a" icon v-if="canRemoveValue" @click="remove(entry)">
          <ux-icon icon="fa-times" />
        </ux-button>
      </flex-cell>
    </flex-row>
    <ux-button v-if="canAddValue" @click="add()">{{ addLabel }}</ux-button>
  </div>
  <template v-else>
    <compile v-if="field.compile" :template="field.template" />
    <div v-else v-html="field.template" />

    <!-- <div v-html="field.template"></div> -->
  </template>
</template>
<script>
import InputMixin from "./input-mixin";

export default {
  props: {
    modelValue: {
      type: [String, Array],
    },
  },
  mixins: [InputMixin],
  methods: {
    getNewDefaultEntry() {
      return "";
    },
  },
};
</script>
<style lang="scss" scoped></style>
